// extracted by mini-css-extract-plugin
export default {"rockets":"Rockets_rockets__VC2N6"};